var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEuros(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "#F7F7FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12270_11148)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.6816 27.0751C38.6816 28.595 34.164 29.827 28.5913 29.827C23.0186 29.827 18.501 28.595 18.501 27.0751C18.501 25.5553 23.0186 24.3232 28.5913 24.3232C34.164 24.3232 38.6816 25.5553 38.6816 27.0751Z",
    fill: "#B1B0F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6806 33.496C38.6806 35.0159 34.163 36.2479 28.5903 36.2479C23.0176 36.2479 18.5 35.0159 18.5 33.496C18.5 31.9762 23.0176 30.7441 28.5903 30.7441C34.163 30.7441 38.6806 31.9762 38.6806 33.496Z",
    fill: "#E6E5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6806 39.9174C38.6806 41.4373 34.163 42.6693 28.5903 42.6693C23.0176 42.6693 18.5 41.4373 18.5 39.9174C18.5 38.3976 23.0176 37.1655 28.5903 37.1655C34.163 37.1655 38.6806 38.3976 38.6806 39.9174Z",
    fill: "#E6E5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6806 46.3383C38.6806 47.8582 34.163 49.0902 28.5903 49.0902C23.0176 49.0902 18.5 47.8582 18.5 46.3383C18.5 44.8185 23.0176 43.5864 28.5903 43.5864C34.163 43.5864 38.6806 44.8185 38.6806 46.3383Z",
    fill: "#E6E5FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5903 29.8271C34.163 29.8271 38.6806 28.595 38.6806 27.0752V31.6617C38.6806 33.1815 34.163 34.4136 28.5903 34.4136C23.0176 34.4136 18.5 33.1815 18.5 31.6617V27.0752C18.5 28.595 23.0176 29.8271 28.5903 29.8271Z",
    fill: "#8E8CEE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5903 36.248C34.163 36.248 38.6806 35.0159 38.6806 33.4961V38.0826C38.6806 39.6024 34.163 40.8345 28.5903 40.8345C23.0176 40.8345 18.5 39.6024 18.5 38.0826V33.4961C18.5 35.0159 23.0176 36.248 28.5903 36.248Z",
    fill: "#8E8CEE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5903 42.6694C34.163 42.6694 38.6806 41.4373 38.6806 39.9175V44.504C38.6806 46.0238 34.163 47.2559 28.5903 47.2559C23.0176 47.2559 18.5 46.0238 18.5 44.504V39.9175C18.5 41.4373 23.0176 42.6694 28.5903 42.6694Z",
    fill: "#8E8CEE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5903 49.0903C34.163 49.0903 38.6806 47.8582 38.6806 46.3384V50.9249C38.6806 52.4447 34.163 53.6768 28.5903 53.6768C23.0176 53.6768 18.5 52.4447 18.5 50.9249V46.3384C18.5 47.8582 23.0176 49.0903 28.5903 49.0903Z",
    fill: "#8E8CEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8574 38.9556C64.3669 47.6623 58.8588 55.8875 50.5548 57.3272C42.2508 58.7669 34.2954 52.8758 32.7859 44.1691C31.2764 35.4625 36.7845 27.2372 45.0885 25.7975C53.3925 24.3579 61.3479 30.249 62.8574 38.9556Z",
    fill: "url(#paint0_linear_12270_11148)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.1277 54.864C57.1342 53.6492 61.7817 46.7092 60.508 39.3629C59.2344 32.0167 52.522 27.0461 45.5155 28.2608C38.509 29.4755 33.8616 36.4156 35.1352 43.7618C36.4088 51.1081 43.1212 56.0787 50.1277 54.864ZM50.5548 57.3272C58.8588 55.8875 64.3669 47.6623 62.8574 38.9556C61.3479 30.249 53.3925 24.3579 45.0885 25.7975C36.7845 27.2372 31.2764 35.4625 32.7859 44.1691C34.2954 52.8758 42.2508 58.7669 50.5548 57.3272Z",
    fill: "url(#paint1_linear_12270_11148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8672 40.5321L42.1904 40.3027C42.2054 39.407 42.3245 38.5788 42.5475 37.8182C42.7762 37.0491 43.0955 36.3723 43.5052 35.7877C43.9218 35.202 44.4205 34.721 45.0013 34.345C45.589 33.9677 46.248 33.7158 46.9785 33.5891C47.9502 33.4207 48.8151 33.4754 49.5731 33.7533C50.3368 34.0228 51.0037 34.4505 51.5737 35.0364L50.7561 36.3392C50.6954 36.4391 50.6299 36.5323 50.5597 36.6189C50.4883 36.6983 50.3768 36.7511 50.2252 36.7774C50.0736 36.8037 49.9257 36.7698 49.7816 36.6756C49.6444 36.5804 49.4812 36.4784 49.292 36.3698C49.1016 36.2539 48.8688 36.1603 48.5938 36.0889C48.3188 36.0175 47.9677 36.0189 47.5404 36.0929C46.803 36.2208 46.2222 36.5968 45.7981 37.2211C45.3808 37.8442 45.1568 38.7018 45.1261 39.7937L50.1189 38.9281L50.2748 39.8277C50.3049 40.0011 50.2614 40.1799 50.1442 40.3639C50.0327 40.5396 49.8563 40.6483 49.6151 40.6901L45.2115 41.4535C45.2234 41.5631 45.2394 41.6757 45.2594 41.7913C45.2782 41.8997 45.2977 42.0117 45.3177 42.1273L45.3966 42.5825L49.6038 41.8531L49.7598 42.7527C49.7898 42.9261 49.7463 43.1048 49.6291 43.2889C49.5176 43.4645 49.3447 43.5727 49.1104 43.6133L45.8335 44.1814C46.2188 45.298 46.7118 46.0945 47.3126 46.5709C47.9134 47.0472 48.5824 47.2215 49.3198 47.0937C49.6299 47.0399 49.8896 46.9614 50.0989 46.8581C50.315 46.7537 50.4942 46.6407 50.6364 46.5193C50.7855 46.3967 50.9058 46.2717 50.9973 46.1442C51.0875 46.0094 51.1692 45.8873 51.2425 45.7779C51.3227 45.6672 51.3985 45.5722 51.47 45.4928C51.5483 45.4123 51.6426 45.3624 51.7528 45.3433C51.8424 45.3278 51.9173 45.3297 51.9774 45.349C52.0432 45.36 52.1174 45.3992 52.2001 45.4667L53.6435 46.4222C53.3058 47.2995 52.7943 48.0133 52.1089 48.5638C51.4235 49.1143 50.588 49.475 49.6026 49.6459C48.7894 49.7869 48.0345 49.7726 47.3378 49.6031C46.6468 49.4252 46.0185 49.1173 45.4528 48.6795C44.8871 48.2417 44.3893 47.6842 43.9596 47.007C43.5299 46.3298 43.1725 45.5582 42.8875 44.6921L41.6263 44.9108L41.3445 43.285L42.4712 43.0897C42.4506 43.0114 42.434 42.9361 42.4214 42.8639C42.4089 42.7916 42.3957 42.7158 42.382 42.6363C42.3619 42.5207 42.3425 42.4087 42.3237 42.3003C42.3118 42.1907 42.2993 42.0775 42.2861 41.9607L41.1491 42.1579L40.8672 40.5321Z",
    fill: "#8E8CEE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12270_11148",
    x1: 51.9226,
    y1: 31.7171,
    x2: 42.0651,
    y2: 45.0289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#E6E5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78135,
    stopColor: "#D5D5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6D6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12270_11148",
    x1: 42.4397,
    y1: 38.4358,
    x2: 48.1899,
    y2: 30.6706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E8CEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.604167,
    stopColor: "#8E8CEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.604267,
    stopColor: "#B1B0F5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12270_11148"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEuros);
export default __webpack_public_path__ + "static/media/euros.7d10ab4a634fe8f400d76b1b0c0d0ff1.svg";
export { ForwardRef as ReactComponent };